package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentDashboardResponse(
    @SerialName("parent_id") val parentId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("parent_name") val parentName: String? = null,
    @SerialName("academic_year_id") val academicYearId: String? = null,
    @SerialName("academic_year_label") val academicYearLabel: String? = null,
    @SerialName("academic_year_start_date") val academicYearStartDate: String? = null,
    @SerialName("academic_year_end_date") val academicYearEndDate: String? = null,
    val children: List<ParentDashboardChildResponse>? = null,
    val statistics: ParentDashboardStatisticsResponse? = null,
    val attendance: List<ParentDashboardAttendanceResponse>? = null,
    val homework: List<ParentDashboardHomeworkResponse>? = null,
    val notices: List<ParentDashboardNoticeResponse>? = null,
    val events: List<ParentDashboardEventResponse>? = null,
    @SerialName("exam_results") val examResults: List<ParentDashboardExamResultResponse>? = null
)

@Serializable
data class ParentDashboardChildResponse(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("student_name") val studentName: String? = null,
    @SerialName("roll_number") val rollNumber: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null
)

@Serializable
data class ParentDashboardStatisticsResponse(
    @SerialName("new_notices_count") val newNoticesCount: Int? = null,
    @SerialName("new_teacher_notes_count") val newTeacherNotesCount: Int? = null,
    @SerialName("attendance_percentage") val attendancePercentage: Double? = null,
    @SerialName("attendance_present_days") val attendancePresentDays: Int? = null,
    @SerialName("attendance_total_days") val attendanceTotalDays: Int? = null,
    @SerialName("exam_result_percentage") val examResultPercentage: Double? = null
)

@Serializable
data class ParentDashboardAttendanceResponse(
    val id: String? = null,
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("attendance_date") val attendanceDate: String? = null,
    val status: String? = null,
    val remarks: String? = null
)

@Serializable
data class ParentDashboardHomeworkResponse(
    val id: String? = null,
    val title: String? = null,
    val description: String? = null,
    @SerialName("due_date") val dueDate: String? = null,
    val status: String? = null,
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("subject_id") val subjectId: String? = null
)

@Serializable
data class ParentDashboardNoticeResponse(
    val id: String? = null,
    val title: String? = null,
    @SerialName("notice_id") val noticeId: String? = null,
    val audience: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)

@Serializable
data class ParentDashboardEventResponse(
    val id: String? = null,
    val title: String? = null,
    @SerialName("event_id") val eventId: String? = null,
    val audience: String? = null,
    @SerialName("event_date") val eventDate: String? = null,
    val description: String? = null
)

@Serializable
data class ParentDashboardExamResultResponse(
    val id: String? = null,
    @SerialName("exam_id") val examId: String? = null,
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("marks_obtained") val marksObtained: Double? = null,
    @SerialName("is_absent") val isAbsent: Boolean? = null,
    @SerialName("teacher_remarks") val teacherRemarks: String? = null
)
